import React from "react";

function TodosLoading() {
  return <p>Loading information...</p>;
}

export { TodosLoading };
